export default "__VITE_ASSET__HoAn8lBm__"